export default __webpack_public_path__ + "static/media/celeste-asistencia-en-viajes-logo.73deb23d.webp";